import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import { ContextoSesionProvider } from './miscelaneo/ContextoSesion';
import { ContextoImpresionProvider } from './contexts/ContextoImpresion';
import { ContextoBalanzaProvider } from './contexts/ContextoBalanza';
import { ContextoScannerProvider } from './contexts/ContextoScanner';
import BannerSinConexion from './miscelaneo/BannerSinConexion';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
  <BrowserRouter>
    <ContextoSesionProvider>
      <ContextoImpresionProvider>
        <ContextoBalanzaProvider>
          <ContextoScannerProvider>
            <App />
            <BannerSinConexion />
            <ToastContainer/>
          </ContextoScannerProvider>
        </ContextoBalanzaProvider>
      </ContextoImpresionProvider>
    </ContextoSesionProvider>
  </BrowserRouter>
  </React.StrictMode>
);

